const getMainBuyButton = () => {
	const button = document.querySelector('.product-form button[type="submit"], .product-form [data-confirmation-modal-trigger]')
	return {
		button: button,
		useConfirmationModal: buttonUsesConfirmationModal(button)
	}
}

const buttonUsesConfirmationModal = (button) => {
	return button.hasAttribute('data-confirmation-modal-trigger')
}

const setupChainSelector = async () => {
	const container = document.querySelector('.product-detail')
	const chainForms = document.querySelectorAll('.pendant-chain-selector')
	const productForm = document.querySelector('.product-form .product-purchase-form')

	const productGallery = document.querySelector('.product-detail .gallery')
	let selectedChainProductId = null
	let chainVariantId = null
	if(!chainForms || chainForms.length === 0) return

	console.info('Pendants:', 'setup', {
		chainForms: chainForms,
		productForm: productForm,
		productGallery: productGallery,
	})
	if (!productForm) return console.info('Pendants:', 'No product form found')

    // Updated addToCart method that adds both the chain and the pendant to the cart
	const addToCart = async (event, skipModal = false) => {
		// Reset any saved items to add
		window.Made2Order = {
			...(window.Made2Order ?? {}),
			itemsToAdd: [],
		}
        event.preventDefault()
        event.stopPropagation()
		
		// If the user has not made a selection and has not explicitly selected "none",
		// we show a pop-up
		if(!skipModal && !selectedChainProductId ){
			container.dispatchEvent(
				new CustomEvent('showChainsModal', {
					detail: {
						productId: selectedChainProductId,
					},
					bubbles: true
				})
			)
						
			return
		}
        const formData = new FormData(productForm)
		
		const properties = {}

		for (const [key, value] of formData.entries()) {
			if (key.startsWith('properties[')) {
				const propertyKey = key.split('[')[1].split(']')[0]
				properties[propertyKey] = value
			}
		}

		const NOTE_KEY_PARTIALS = ['note']
		let note = ''
		Object.keys(properties).forEach((key) => {
			if (
				NOTE_KEY_PARTIALS.some((partial) =>
					key.toLowerCase().includes(partial)
				)
			) {
				note = properties[key]
				delete properties[key]
			}
		})

        const itemsToAdd = [
            {
                id: formData.get('id'),
                quantity: 1,
				...(Object.keys(properties).length > 0 ? { properties: properties } : {}),
            }
        ]

        if(chainVariantId) {
			const variantId = formData.get('id')
			const variantTitle = formData.get('variant-title')
			let extra = ''
			if(variantId || variantTitle) {
				extra += '('
				if(variantTitle) {
					extra += `${variantTitle}`
				}
				if(variantId) {
					extra += `${variantTitle ? ', ' : ''}${variantId}`
				}
				extra += ')'
			}
            itemsToAdd.push({
                id: chainVariantId,
                quantity: 1,
				properties: {
					_addon: `${formData.get('product-title')} ${extra}`
				}
            })
        }
		
		// If the user has to confirm the order, we show the confirmation modal before adding to cart
		if(getMainBuyButton().useConfirmationModal){
			const confirmationModalId = getMainBuyButton().button.getAttribute('data-cc-modal-contentelement')
			const confirmationModal = document.querySelector(confirmationModalId)

			// Save the items to add for reference in the confirmation modal
			window.Made2Order = {
				...(window.Made2Order ?? {}),
				itemsToAdd: itemsToAdd,
			}

			container.dispatchEvent(new CustomEvent('closeChainsModal', {bubbles: true}))

			confirmationModal.dispatchEvent(new CustomEvent('open', {bubbles: true}))

			return
		}

		const html = getMainBuyButton().button.innerHTML
		getMainBuyButton().button.innerHTML = '<div class="loading-spinner loading-spinner--in-btn"></div>' 

		const response = await fetch(`${window.routes.cartUrl}/add.js`, {
			method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
			body: JSON.stringify({
				items: itemsToAdd,
				note: note ? note : undefined,
			}),
		})

		window.theme.addedToCartHandler(response)

		window.dispatchEvent(new CustomEvent('closeChainsModal',{
			detail: {
				reset: false
			},
			bubbles: true
		}))

		getMainBuyButton().button.innerHTML = html
	}

	const setupChainFormListeners = () => {
		if (chainForms.length > 0) {

			const oldMainBuyButton = getMainBuyButton().button
			const mainBuyButton = oldMainBuyButton.cloneNode(true)

			// This wipes any event listeners from the old button
			// Such as the one that opens the confirmation modal, so we can trigger it ourselves
			oldMainBuyButton.parentNode.replaceChild(mainBuyButton, oldMainBuyButton)

			mainBuyButton.addEventListener('click', addToCart)
		
			chainForms.forEach((chainForm) => {
				const formBuyButton = chainForm.querySelector('button[data-submit]') ?? mainBuyButton
				const formSkipButton = chainForm.querySelector('button[data-skip]')
				if(formBuyButton !== mainBuyButton){
					formBuyButton.addEventListener('click', (event) => addToCart(event, true))
				}
				if(formSkipButton){
					formSkipButton.addEventListener('click', (event) => addToCart(event, true))
				}
				const context = chainForm.dataset.context
	
				const chainVariantSelectors = chainForm.querySelectorAll(
					'.option-selector[data-chain-id]'
				)
				if (chainVariantSelectors.length == 0) return
		
				const chainProductSelector =
				chainForm.querySelector('.option-selector')
				const chainProductOptionInputs =
					chainProductSelector.querySelectorAll('input')
	
				chainProductOptionInputs.forEach((chainProductOptionInput) => {
					chainProductOptionInput.addEventListener('change', () => {
						const value = chainProductOptionInput.value
	
						// Uncheck all other chain product options
						chainProductOptionInputs.forEach((c) => {
							if (c !== chainProductOptionInput){
								c.checked = false
							}
						})
	
						if (chainProductOptionInput.checked) {
							container.dispatchEvent(
								new CustomEvent(`chainProductChanged-${context}`, {
									detail: { value, button: formBuyButton },
									bubbles: true
								})
							)
							if(value !== 'none'){
								formSkipButton?.classList.add('hidden')
							}else{
								formSkipButton?.classList.remove('hidden')
							}
						}else{
							formSkipButton?.classList.remove('hidden')
							container.dispatchEvent(
								new CustomEvent(`chainProductChanged-${context}`, {
									detail: { value: null, button: formBuyButton },
									bubbles: true
								})
							)
						}
					})
				})
	
				container.addEventListener(`chainProductChanged-${context}`, (event) => {
					selectedChainProductId = event.detail.value
					const button = event.detail.button
	
					// Hide all chain variant selectors
					chainVariantSelectors.forEach((chainVariantSelector) => {
						chainVariantSelector.classList.add('hidden')
					})
	
					if (selectedChainProductId === 'none' || !selectedChainProductId) {
						console.info('Pendants:', 'Chain de-selected', button)
						chainVariantId = null
	
						// Uncheck all chain variant options
						chainVariantSelectors.forEach((chainVariantSelector) => {
							const chainVariantOptionInputs =
								chainVariantSelector.querySelectorAll('input')
							chainVariantOptionInputs.forEach((chainVariantOptionInput) => {
								chainVariantOptionInput.checked = false
							})
						})
	
						if(context === 'modal'){
							button.disabled = true
							button.textContent = buttonUsesConfirmationModal(getMainBuyButton().button) ? button.dataset.orderText : button.dataset.addToCartText
						}else{
							button.textContent = button.dataset.addToCartText
						}
						return
					}
	
					button.disabled = false
	
					const isMobile = window.innerWidth < 768
	
					// If browsing from mobile, we open the modal for easier selection
					if(isMobile){
						container.dispatchEvent(
							new CustomEvent('showChainsModal', {
								detail: {
									productId: selectedChainProductId,
								},
								bubbles: true
							})
						)
					}
	
					if(context !== 'modal' && !isMobile){
						// Highlight selected chain image using the theme's product gallery
						theme.jQuery(productGallery).trigger('variantImageSelected', [{
							featured_media: {
								id: selectedChainProductId,
							}
						}])
					}else{
						// If context is modal, switch to the chain image if available
						const modalChainImage = document.querySelector(`#chains-modal [data-modal-chain-image="${selectedChainProductId}"]`)
						if(modalChainImage){
							const allModalChainImages = document.querySelectorAll(`#chains-modal [data-modal-chain-image],#chains-modal [data-modal-shared-chains-image]`)
							allModalChainImages.forEach((image) => {
								image.style.display = 'none'
							})
							modalChainImage.style.display = 'unset'
						}
					}
	
					const selectedChainVariantSelector = chainForm.querySelector(
						`.option-selector[data-chain-id="${selectedChainProductId}"]`
					)
					selectedChainVariantSelector.classList.remove('hidden')
	
					// Click first option in chain variant selector
					const firstChainVariantOptionInput =
						selectedChainVariantSelector.querySelector('input')
					firstChainVariantOptionInput.click()
				})
	
				// Register chain variants, listen for chain variant selection and update total price accordingly
				chainVariantSelectors.forEach((chainVariantSelector) => {
					const chainVariantOptionInputs =
						chainVariantSelector.querySelectorAll('input')
					chainVariantOptionInputs.forEach((chainVariantOptionInput) => {
						
						chainVariantOptionInput.addEventListener('change', () => {
							const variantId = chainVariantOptionInput.value
							const combinedPriceDisplay =
								chainVariantOptionInput.dataset.combinedPriceDisplay
							chainVariantId = variantId
							if (chainVariantOptionInput.checked) {
								formBuyButton.textContent = (getMainBuyButton().useConfirmationModal ? chainForm.dataset.orderText : chainForm.dataset.addToCartText) + ' ' + combinedPriceDisplay
							}
						})

					})
				})
			})
		}
	}

	setupChainFormListeners()

	jQuery('.product-form').on('variantChanged', () => {
		setupChainFormListeners()
	})

	
}

const setupChainsModal = () => {
	const chainsModal = document.getElementById('chains-modal')
	if (!chainsModal) return
	const closeButton = chainsModal.querySelector('.cc-modal-window__close')
	const background = chainsModal.querySelector('.cc-modal-window__background')

	const showModal = () => {
		chainsModal.classList.remove('hidden')
		setTimeout(() => {
			chainsModal.classList.remove('cc-modal-window--pre-reveal')
		}, 10)
	}
	
	const hideModal = (reset) => {
		chainsModal.classList.add('cc-modal-window--closing')
		setTimeout(() => {
			chainsModal.classList.add('hidden','cc-modal-window--pre-reveal')
			chainsModal.classList.remove('cc-modal-window--closing')

			// Reset chain selection
			if(reset){
				window.dispatchEvent(new CustomEvent('chainProductChanged-product-page', {
					detail: {
						value: null,
						button: getMainBuyButton().button
					},
					bubbles: true
				}))
			}
		}, 250)
	}

	closeButton.addEventListener('click', () => hideModal(true))
	background.addEventListener('click', () => hideModal(true))

	window.addEventListener('showChainsModal', (event) => {
		const productId = event.detail.productId

		if(productId && productId !== 'none'){
			const input = chainsModal.querySelector(`input[value="${productId}"]`)
			if(input){
				input.click()	
			}
		}
		
		showModal()
	})

	window.addEventListener('closeChainsModal', (event) => {
		hideModal(event.detail?.reset)
	})

	// move chains modal to root
	document.body.appendChild(chainsModal)

}

const setupChainDropdown = () => {
	console.info("Pendants:", "Setting up chain dropdown")
	const chainDropdown = document.querySelector('.chain-dropdown')
	console.info("Pendants:", "Chain dropdown", chainDropdown)
	if(!chainDropdown) return // In cases where there are less than 3 chain options
	const selectedChainContent = chainDropdown.querySelector('[data-selected-chain]')	
	const context = 'modal'
	const chainDropdownButton = chainDropdown.querySelector('button')
	const dropdownOptions = chainDropdown.querySelector('[data-dropdown-options]')
	const chainProductOptions = document.querySelectorAll('.chain-dropdown + .option-selector__btns >*:not(.deselect-chain)')

	// Move all options into the dropdown
	chainProductOptions.forEach((option) => {
		dropdownOptions.appendChild(option)
	})

	const showOptions = () => {
		dropdownOptions.classList.remove('hidden')
	}

	const hideOptions = () => {
		dropdownOptions.classList.add('hidden')
	}

	document.addEventListener(`chainProductChanged-${context}`, (event) => {
		selectedChainProductId = event.detail.value
		const chainProductDisplay = document.querySelector(`input[name="chain-${context}"][value="${selectedChainProductId}"] + label`)
		if(selectedChainProductId && selectedChainProductId !== "none" && chainProductDisplay){
			selectedChainContent.innerHTML = chainProductDisplay.innerHTML
		}else if(!selectedChainProductId || selectedChainProductId === "none"){
			selectedChainContent.innerHTML = chainDropdownButton.dataset.emptyText
		}
		
		hideOptions()
	})

	chainDropdownButton.addEventListener('click', () => {
		console.info("Pendants:", "Toggling dropdown")
		if(dropdownOptions.classList.contains('hidden')){
			showOptions()
		}else{
			hideOptions()
		}
	})

	// Close dropdown when clicking outside
	document.addEventListener('click', (event) => {
		if(!chainDropdown.contains(event.target)){
			hideOptions()
		}
	})

}

const isMobile = () => window.innerWidth < 768

setTimeout(() => {
	setupChainSelector()
	setupChainsModal()
	
	if(isMobile()){
		setupChainDropdown()
	}
}, 200)

document.addEventListener('product:swapped', () => {
	console.info('Pendants:', 'Product swapped')
	document.querySelector('#chains-modal')?.remove() // Remove re-created modal
	setupChainSelector()
	//setupChainsModal()
	if(isMobile()){
		//setupChainDropdown()
	}
})

